import BoletoForm from 'subscription-flow/boleto/BoletoForm'
import InfoPopup from 'shared/components/InfoPopup'
import styles from '../styles.module.scss'

const BoletoInfo = ({ boletoClassName, setUsingBoleto, setFormBoletoData, setIsFormBoletoValid }) => (
    <div className={boletoClassName} onClick={setUsingBoleto}>
        <div className="mb-3">
            <div className={styles.boletoHeader}>
                <h6 className={styles.boletoTitle}>
                    <T>subscription.purchase.boleto</T>
                </h6>
                <InfoPopup
                    className="ml-2"
                    content={<T>subscription.purchase.boleto.info.content</T>}
                    title={<T>subscription.purchase.boleto.info.title</T>}
                />
            </div>
            <div className="text-small text-light">
                <T>subscription.purchase.boleto.hint</T>
            </div>
        </div>
        <BoletoForm
            onChange={setFormBoletoData}
            onValid={() => {
                setIsFormBoletoValid(true)
            }}
            onInvalid={() => {
                setIsFormBoletoValid(false)
            }}
        />
    </div>
)

export default BoletoInfo
